export default "__VITE_ASSET__34f6612a__"